module.exports = __webpack_public_path__ + "static/media/HUSD.0710460c.svg";